import { KycStatus } from '@/constants'

export interface State {
  hasActiveReleases: boolean,
  hasSubscriptionError: boolean,
  payoutAccounts: PayoutAccount[],
  user: User,
  userProfile: UserProfile,
  userCurrencyConversionRate: number,
}

export default <State> {
  hasActiveReleases: false,
  hasSubscriptionError: false,
  payoutAccounts: [],
  user: {
    id: null,
    roles: [],
    username: '',
    email: '',
    subscription: undefined,
    status: {
      activated: false,
      isSubscriptionNotRequired: null,
      kyc: KycStatus.required,
      notSuspended: true,
      payouts: false,
    },
  },
  userProfile: {
    id: 0,
    email: '',
    emailToVerify: '',
    firstName: '',
    lastName: '',
    isSubscribedToMailingList: false,
    isActivated: false,
    isRegisteredWriter: false,
    avatar: {
      small: '',
      medium: '',
      large: '',
    },
    statistics: {
      artistCount: 0,
      musicReleaseCount: 0,
      videoReleaseCount: 0,
    },
    passwordSetAt: 0,
    currency: '',
  },
  userCurrencyConversionRate: 0,
}
